import { observer } from 'mobx-react-lite'

import { EmployeeRolesForm } from 'sections/LKSection/modules/EmployeeModule/components/Forms/EmployeeRolesForm/EmployeeRolesForm'

export const EmployeeRolesStep = observer(() => {
  return <EmployeeRolesForm formType="add" />
})
